export default "__VITE_ASSET__ui64ZSx___"